<template>
  <nav
    class="w-64 select-none transition duration-500 ease-in-out flex flex-col shadow-lg bg-gray-200"
  >
    <!--    Company information-->
    <div class="flex flex-col justify-center items-center h-40 w-full relative">
      <img
        src="../../assets/images/logo-1.png"
        class="w-full scale-[1.15]"
        alt="TNH Logo"
      />
      <!-- <div
        class="absolute top-[106px] mx-4 text-center text-sm font-semibold text-[#114b7c] capitalize"
      >
        Fast Speed - Safe Journey
      </div> -->
    </div>

    <!-- <div class="text-center p-4 border-b" v-if="user">
            <template v-if="userAvatar?.photo?.data?.url">
                <div class="flex justify-between md">
                    <div class="ml-3">
                        <a :href="`/user/profile`">
                            <div
                                class="h-24 w-24 rounded-full mx-auto bg-no-repeat bg-center bg-cover"
                                :style="{
                                    backgroundImage:
                                        'url(' +
                                        userAvatar?.photo?.data?.url +
                                        ')',
                                }"
                            ></div>
                        </a>
                    </div>
                    <div class="mr-4 flex items-center">
                        <a class="" :href="`/user/profile`">
                            <p class="text-lg font-semibold mb-2">
                                {{ user.name }}
                            </p>
                            <p class="text-sm text-gray-600">
                                {{ user.shop_code }}
                            </p>
                        </a>
                    </div>
                </div>
            </template>
            <template v-else>
                <a :href="`/user/profile`">
                    <p class="pt-2 text-lg font-semibold">{{ user.name }}</p>
                    <p class="text-sm text-gray-600">{{ user.shop_code }}</p>
                </a>
            </template>
        </div> -->

    <!--    Menu-->
    <div
      class="flex-1 overflow-hidden bg-main z-[1]"
      style="
        border-radius: 0 25px 0 0;
        border: solid 1px #114b7c;
        background: radial-gradient(circle at 50% 50%, #5de0e6, #0078a6);
        box-shadow: 0px -7px 50px #114b7c;
      "
    >
      <ul>
        <menu-item path="/packages" name="Danh sách đơn hàng">
          <img
            :src="icons.packageListIcon"
            alt="packageListIcon"
            class="h-5 w-5"
          />
        </menu-item>

        <menu-item path="/live-dashboard" name="Thống kê đơn hàng">
          <img
            :src="icons.homeIcon"
            alt="Home Icon"
            class="h-5 w-5 text-white"
          />
        </menu-item>

        <!-- <menu-item
                    path="/packages/create"
                    :name="$t('text.create_package')"
                >
                    <img
                        :src="icons.packageCreateIcon"
                        alt="Home Icon"
                        class="h-5 w-5"
                    />
                </menu-item> -->

        <!-- <menu-item
                    path="/packages/upload-excel"
                    :name="$t('text.create_package_with_excel')"
                >
                    <img
                        :src="icons.excelIcon"
                        alt="excelIcon"
                        class="h-5 w-5"
                    />
                </menu-item> -->

        <menu-item path="/cod" name="Quản lý đối soát">
          <img :src="icons.codIcon" alt="codIcon" class="h-5 w-5" />
        </menu-item>

        <menu-item path="/stores" :name="$t('text.store_management')">
          <img :src="icons.storeIcon" alt="storeIcon" class="h-5 w-5" />
        </menu-item>

        <menu-item path="/support" :name="$t('text.support')">
          <img :src="icons.supportIcon" alt="supportIcon" class="h-5 w-5" />
        </menu-item>

        <menu-item
          path="/user/profile"
          :name="
            user?.shop?.data?.shop_type == 'Shop/Organization'
              ? 'Doanh nghiệp'
              : 'Thông tin tài khoản'
          "
        >
          <img :src="icons.userIcon" alt="userIcon" class="h-5 w-5" />
        </menu-item>
      </ul>
    </div>

    <!-- <div class=" h-full">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                />
            </svg>
            <langselector />
        </div> -->

    <!-- <div class="bg-main pb-4">
            <div
                @click="logout"
                class=" border py-2 text-center mx-2 rounded-lg "
            >
                <a href="#" class="font-semibold text-white">
                    {{ $t("text.logout") }}
                </a>
            </div>
        </div> -->
  </nav>
</template>

<script lang="ts">
import { computed, onMounted, ref } from "vue";
import MenuItem from "./MenuItem.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import userApi from "../../api/user";
import Langselector from "./Langselector.vue";
import icons from "../../assets/svgs";

export default {
  name: "ShopSidebar",
  components: { MenuItem, Langselector, icons },
  setup() {
    const open = ref(false);

    const store = useStore();
    const router = useRouter();
    const user = ref({});
    const getInfo = async function () {
      const { data } = await userApi.getUserInfo(
        `?include=photo,default_store,shop`
      );
      user.value = data.data;
      await store.commit("user/SET_USER_INFORMATION", data.data);
    };
    const userAvatar = computed(() => store.state.user.userInfo);

    onMounted(() => {
      if (localStorage.getItem("access_token")) {
        getInfo();
      }
    });

    async function logout() {
      await store.dispatch("logout");
      await router.push({ name: "Login" });
    }

    return {
      open,
      logout,
      user,
      userAvatar,
      icons,
    };
  },
};
</script>
